export default function AgentDetailSkeleton() {
  return (
    <div className="min-h-screen bg-background">
      <div className="mx-auto max-w-7xl px-4 py-8 grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* Left: Image + Info */}
        <div className="lg:col-span-2 space-y-6">
          <div className="rounded-2xl bg-surface-1 border border-border/50 overflow-hidden">
            <div className="h-64 w-full bg-surface-2 animate-pulse" />
            <div className="p-6 space-y-4">
              <div className="h-8 w-3/4 bg-surface-2 rounded-lg animate-pulse" />
              <div className="h-4 w-full bg-surface-2 rounded-lg animate-pulse" />
              <div className="h-4 w-5/6 bg-surface-2 rounded-lg animate-pulse" />
              <div className="h-4 w-2/3 bg-surface-2 rounded-lg animate-pulse" />
            </div>
          </div>
        </div>
        
        {/* Right: Pricing + CTA */}
        <div className="space-y-6">
          <div className="rounded-2xl bg-surface-1 border border-border/50 p-6">
            <div className="h-6 w-1/2 bg-surface-2 rounded-lg animate-pulse mb-4" />
            <div className="h-10 w-full bg-surface-2 rounded-lg animate-pulse mb-4" />
            <div className="h-12 w-full bg-brand-glow/20 rounded-lg animate-pulse" />
          </div>
        </div>
      </div>
    </div>
  );
}
